export const sx = {
    root: {
        paddingTop:'15px',
        borderRadius:'4px',
        boxShadow:'0 4px 10px 0 rgba(0, 0, 0, 0.1)',
        margin: "0",
        "& ul": {padding: "10px 10px"},
        "& li": {padding: "0 10px"},
    },
    button: {
        padding: "0",
        margin: "0",
        minWidth: "auto",
        transition: "all .3s",
        '&.disabled': {
            opacity: '.5'
        }
    },
    innerBtn: {
       paddingBottom:'5px',
        width:'100%'
    },
    iconClose:{
        width:'10px',
        height:'10px',
        color:'#bebcb9'
    },
}